module.exports = __webpack_public_path__ + "img/copy.52445164.svg";